module.exports = __webpack_public_path__ + "static/cur-793d164a82dd631970a6e40e95057c4c.png";